export default __webpack_public_path__ + "static/media/project.66d510f7.png";